module.exports = __webpack_public_path__ + "img/pos3_banner.8334a323.jpg";